<template>
  <section id="classement_tab">
    <b-container fluid style="padding: 0">
      <b-row>
        <b-col md="4" style="margin-bottom: 5px">
          <b-form-input v-model="$store.state.search_terms" placeholder="Rechercher..."></b-form-input>
        </b-col>
        <b-col md="12" style="text-align: left">
          <b-button-group class="button_group_filter_classement flex-wrap">
            <b-button @click="selectClassementType('Homme')" v-bind:class="[$store.state.classement_type === 'Homme' ? 'active_classement' : '']">Homme</b-button>
            <b-button @click="selectClassementType('Femme')" v-bind:class="[$store.state.classement_type === 'Femme' ? 'active_classement' : '']">Femme</b-button>
            <b-button @click="selectClassementType('Club')" v-bind:class="[$store.state.classement_type === 'Club' ? 'active_classement' : '']">Club</b-button>
            <b-button @click="selectClassementType('Perf_Club')" v-bind:class="[$store.state.classement_type === 'Perf_Club' ? 'active_classement' : '']">Performances Club</b-button>
            <b-button @click="selectClassementType('Entreprise')" v-bind:class="[$store.state.classement_type === 'Entreprise' ? 'active_classement' : '']">Entreprise</b-button>
            <b-button @click="selectClassementType('Perf_Entreprise')" v-bind:class="[$store.state.classement_type === 'Perf_Entreprise' ? 'active_classement' : '']">Performances entreprise</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row v-if="classement.length > 0">
        <b-col>
          <TableauClassementCoureurs v-if="$store.state.classement_type === 'Homme' || $store.state.classement_type === 'Femme'" :classement="filteredClassement"></TableauClassementCoureurs>
          <TableauClassementOrga v-else :classement="filteredClassement"></TableauClassementOrga>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import axios from "axios";
import TableauClassementCoureurs from "@/components/Classement/TableauClassementCoureurs.vue";
import TableauClassementOrga from "@/components/Classement/TableauClassementOrga.vue";

export default {
  components: {
    TableauClassementCoureurs,
    TableauClassementOrga,
  },
  data() {
    return {
      classement: [],
    };
  },
  computed: {
    filteredClassement() {
      var filteredClassement = JSON.parse(JSON.stringify(this.classement));
      if (this.$store.state.search_terms) {
        if (this.$store.state.classement_type === "Homme" || this.$store.state.classement_type === "Femme") {
          filteredClassement = filteredClassement.filter((item) => item.nom.includes(this.$store.state.search_terms.toUpperCase()) || item.prenom.toUpperCase().includes(this.$store.state.search_terms.toUpperCase()));
        } else {
          filteredClassement = filteredClassement.filter((item) => item.name.includes(this.$store.state.search_terms.toUpperCase()));
        }
      }
      return filteredClassement;
    },
  },
  methods: {
    selectClassementType(type) {
      this.$store.state.classement_type = type;
      this.fetchClassement();
    },
    fetchClassement() {
      var _this = this;
      axios.get(this.$store.state.base_url + "/classement/get.php?category=" + this.$store.state.classement_type).then(function (response) {
        _this.$store.state.classement = response.data;
        _this.classement = response.data;
        _this.$forceUpdate();
      });
    },
  },
  mounted() {
    this.fetchClassement();
  },
};
</script>

<style lang="scss" scoped></style>
